// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteAgentsDeleteAgentData, DeleteAgentsDeleteAgentResponses, DeleteAgentsRemoveAgentCallbackData, DeleteAgentsRemoveAgentCallbackResponses, DeleteDebtorsDeleteRescheduledEventData, DeleteDebtorsDeleteRescheduledEventResponses, DeleteSecureFilesDeleteClientData, DeleteSecureFilesDeleteClientResponses, GetAgentsGetAgentActionsData, GetAgentsGetAgentActionsResponses, GetAgentsGetAgentCallbacksData, GetAgentsGetAgentCallbacksResponses, GetAgentsGetAgentsData, GetAgentsGetAgentsResponses, GetAgentsGetGroupsData, GetAgentsGetGroupsResponses, GetCallsGetCallRecordingData, GetCallsGetCallRecordingResponses, GetCallsGetCallsData, GetCallsGetCallsResponses, GetCallsGetRecentCallsData, GetCallsGetRecentCallsResponses, GetCampaignsListCampaignsData, GetCampaignsListCampaignsResponses, GetDebtorsGetDebtorData, GetDebtorsGetDebtorResponses, GetDebtorsGetPaymentPlansData, GetDebtorsGetPaymentPlansResponses, GetDebtorsListDebtorsData, GetDebtorsListDebtorsResponses, GetDebtorsListRescheduledDebtorsData, GetDebtorsListRescheduledDebtorsResponses, GetIdentityGetIdentityData, GetIdentityGetIdentityResponses, GetIdentityGetSrpcTokenData, GetIdentityGetSrpcTokenResponses, GetIdentityGetStatsData, GetIdentityGetStatsResponses, GetMetaGetActionCodesData, GetMetaGetActionCodesResponses, GetMetaGetAgentsData, GetMetaGetAgentsResponses, GetMetaGetClientInfoData, GetMetaGetClientInfoResponses, GetMetaGetConfigData, GetMetaGetConfigResponses, GetMetaGetCryptoKeyData, GetMetaGetCryptoKeyResponses, GetMetaGetDidsData, GetMetaGetDidsResponses, GetMetaGetQueuesData, GetMetaGetQueuesResponses, GetMetaGetStatusesData, GetMetaGetStatusesResponses, GetMetaGetTrustCodesData, GetMetaGetTrustCodesResponses, GetMetaValidateRoutingNumberData, GetMetaValidateRoutingNumberResponses, GetMlCohortGetConfigData, GetMlCohortGetConfigResponses, GetMlCohortGetQueueImpactData, GetMlCohortGetQueueImpactResponses, GetPh1CcGetClientRecordsData, GetPh1CcGetClientRecordsResponses, GetPh1CcGetClientsData, GetPh1CcGetClientsResponses, GetPifCreditRemovalsGetPifCreditRemovalData, GetPifCreditRemovalsGetPifCreditRemovalResponses, GetPifCreditRemovalsGetPifCreditRemovalsData, GetPifCreditRemovalsGetPifCreditRemovalsResponses, GetPublicFilesDownloadData, GetPublicFilesDownloadResponses, GetPublicFilesGetFileInfoData, GetPublicFilesGetFileInfoResponses, GetPublicFilesGetRecipientFileInfoData, GetPublicFilesGetRecipientFileInfoResponses, GetPublicFilesRecipientDownloadData, GetPublicFilesRecipientDownloadResponses, GetPublicIvrHandleTtsData, GetPublicIvrHandleTtsResponses, GetPublicPayGetConfigData, GetPublicPayGetConfigResponses, GetPublicReceiptsGetReceiptPublicData, GetPublicReceiptsGetReceiptPublicResponses, GetPublicReceiptsGetReceiptPublicSimpleData, GetPublicReceiptsGetReceiptPublicSimpleResponses, GetReceiptsGetReceiptData, GetReceiptsGetReceiptResponses, GetReceiptsGetReceiptsData, GetReceiptsGetReceiptsResponses, GetSecureFilesGetClientsData, GetSecureFilesGetClientsResponses, GetSecureFilesGetPreviewUrlData, GetSecureFilesGetPreviewUrlResponses, GetSecureFilesGetQueuedData, GetSecureFilesGetQueuedResponses, GetSecureFilesGetSentData, GetSecureFilesGetSentDetailsData, GetSecureFilesGetSentDetailsResponses, GetSecureFilesGetSentResponses, GetSecureFilesGetTemplatesData, GetSecureFilesGetTemplatesResponses, PostAdminTerminateData, PostAdminTerminateResponses, PostAdminTerminateSessionGatewayData, PostAdminTerminateSessionGatewayResponses, PostAgentsAddAgentCallbackData, PostAgentsAddAgentCallbackResponses, PostAgentsCreateAgentData, PostAgentsCreateAgentResponses, PostCampaignLoaderLoadCampaignData, PostCampaignLoaderLoadCampaignResponses, PostCardTokenCreateTokenData, PostCardTokenCreateTokenResponses, PostDebtorsCreatePaymentPlanData, PostDebtorsCreatePaymentPlanResponses, PostDebtorsCreateScheduledPaymentData, PostDebtorsCreateScheduledPaymentResponses, PostDebtorsMarkFileClosedData, PostDebtorsMarkFileClosedResponses, PostDebtorsPostActionData, PostDebtorsPostActionResponses, PostDebtorsSendPaymentLinkData, PostDebtorsSendPaymentLinkResponses, PostDebtorsSendReceiptData, PostDebtorsSendReceiptResponses, PostPh1CcPurgeData, PostPh1CcPurgeResponses, PostPostmarkWebhookHandleWebhookData, PostPostmarkWebhookHandleWebhookResponses, PostPublicFilesUploadData, PostPublicFilesUploadResponses, PostPublicFreeSwitchEventHandleEventData, PostPublicFreeSwitchEventHandleEventResponses, PostPublicIvrHandleTwimlData, PostPublicIvrHandleTwimlResponses, PostPublicPayAccountsData, PostPublicPayAccountsResponses, PostPublicPayAuthData, PostPublicPayAuthResponses, PostPublicPayPaymentData, PostPublicPayPaymentResponses, PostPublicPayPlanEnrollData, PostPublicPayPlanEnrollResponses, PostPublicPayPlanOptionsData, PostPublicPayPlanOptionsResponses, PostPublicPayPlanStatusData, PostPublicPayPlanStatusResponses, PostPublicPayPlanUpdateMethodData, PostPublicPayPlanUpdateMethodResponses, PostPublicPayReceiptData, PostPublicPayReceiptResponses, PostPublicPayScheduledPaymentsData, PostPublicPayScheduledPaymentsResponses, PostReceiptsMarkMailedData, PostReceiptsMarkMailedResponses, PostReceiptsPrintReceiptEnvelopesData, PostReceiptsPrintReceiptEnvelopesResponses, PostReceiptsPrintReceiptsData, PostReceiptsPrintReceiptsResponses, PostSecureFilesCreateClientData, PostSecureFilesCreateClientResponses, PostSecureFilesSendFilesData, PostSecureFilesSendFilesResponses, PostTelnyxWebhookHandleWebhookData, PostTelnyxWebhookHandleWebhookResponses, PostUsaepayGatewayHandleGatewayRequestData, PostUsaepayGatewayHandleGatewayRequestResponses, PutAgentsSyncAgentQueuesData, PutAgentsSyncAgentQueuesResponses, PutAgentsUpdateAgentData, PutAgentsUpdateAgentResponses, PutDebtorsCancelPaymentPlanData, PutDebtorsCancelPaymentPlanResponses, PutDebtorsCancelScheduledPaymentData, PutDebtorsCancelScheduledPaymentResponses, PutDebtorsReschedulePaymentData, PutDebtorsReschedulePaymentResponses, PutDebtorsUpdateAddressData, PutDebtorsUpdateAddressResponses, PutDebtorsUpdatePaymentPlanMethodData, PutDebtorsUpdatePaymentPlanMethodResponses, PutDebtorsUpdatePaymentPlanNotificationsData, PutDebtorsUpdatePaymentPlanNotificationsResponses, PutDebtorsUpdateScheduledPaymentReceiptData, PutDebtorsUpdateScheduledPaymentReceiptResponses, PutMetaSetConfigData, PutMetaSetConfigResponses, PutMlCohortSetConfigData, PutMlCohortSetConfigResponses, PutSecureFilesUpdateClientEmailsData, PutSecureFilesUpdateClientEmailsResponses, PutSecureFilesUpdateTemplateData, PutSecureFilesUpdateTemplateResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class AdminApi {
    public static postAdminTerminate<ThrowOnError extends boolean = false>(options?: Options<PostAdminTerminateData, ThrowOnError>): RequestResult<PostAdminTerminateResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostAdminTerminateResponses, unknown, ThrowOnError>({ url: '/admin/terminate', ...options });
    }
    
    public static postAdminTerminateSessionGateway<ThrowOnError extends boolean = false>(options?: Options<PostAdminTerminateSessionGatewayData, ThrowOnError>): RequestResult<PostAdminTerminateSessionGatewayResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostAdminTerminateSessionGatewayResponses, unknown, ThrowOnError>({ url: '/admin/terminate-session-gateway', ...options });
    }
}

export class AgentsApi {
    public static getAgentsGetAgents<ThrowOnError extends boolean = false>(options?: Options<GetAgentsGetAgentsData, ThrowOnError>): RequestResult<GetAgentsGetAgentsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAgentsGetAgentsResponses, unknown, ThrowOnError>({ url: '/agentapp/agents', ...options });
    }
    
    public static postAgentsCreateAgent<ThrowOnError extends boolean = false>(options: Options<PostAgentsCreateAgentData, ThrowOnError>): RequestResult<PostAgentsCreateAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAgentsCreateAgentResponses, unknown, ThrowOnError>({
            url: '/agentapp/agents',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteAgentsDeleteAgent<ThrowOnError extends boolean = false>(options: Options<DeleteAgentsDeleteAgentData, ThrowOnError>): RequestResult<DeleteAgentsDeleteAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAgentsDeleteAgentResponses, unknown, ThrowOnError>({ url: '/agentapp/agents/{id}', ...options });
    }
    
    public static putAgentsUpdateAgent<ThrowOnError extends boolean = false>(options: Options<PutAgentsUpdateAgentData, ThrowOnError>): RequestResult<PutAgentsUpdateAgentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAgentsUpdateAgentResponses, unknown, ThrowOnError>({
            url: '/agentapp/agents/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAgentsGetGroups<ThrowOnError extends boolean = false>(options?: Options<GetAgentsGetGroupsData, ThrowOnError>): RequestResult<GetAgentsGetGroupsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetAgentsGetGroupsResponses, unknown, ThrowOnError>({ url: '/agentapp/agents/groups', ...options });
    }
    
    public static putAgentsSyncAgentQueues<ThrowOnError extends boolean = false>(options: Options<PutAgentsSyncAgentQueuesData, ThrowOnError>): RequestResult<PutAgentsSyncAgentQueuesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutAgentsSyncAgentQueuesResponses, unknown, ThrowOnError>({
            url: '/agentapp/agents/{id}/queues',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAgentsGetAgentActions<ThrowOnError extends boolean = false>(options: Options<GetAgentsGetAgentActionsData, ThrowOnError>): RequestResult<GetAgentsGetAgentActionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetAgentsGetAgentActionsResponses, unknown, ThrowOnError>({ url: '/agentapp/agents/{id}/actions', ...options });
    }
    
    public static deleteAgentsRemoveAgentCallback<ThrowOnError extends boolean = false>(options: Options<DeleteAgentsRemoveAgentCallbackData, ThrowOnError>): RequestResult<DeleteAgentsRemoveAgentCallbackResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteAgentsRemoveAgentCallbackResponses, unknown, ThrowOnError>({
            url: '/agentapp/agents/{id}/callbacks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getAgentsGetAgentCallbacks<ThrowOnError extends boolean = false>(options: Options<GetAgentsGetAgentCallbacksData, ThrowOnError>): RequestResult<GetAgentsGetAgentCallbacksResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetAgentsGetAgentCallbacksResponses, unknown, ThrowOnError>({ url: '/agentapp/agents/{id}/callbacks', ...options });
    }
    
    public static postAgentsAddAgentCallback<ThrowOnError extends boolean = false>(options: Options<PostAgentsAddAgentCallbackData, ThrowOnError>): RequestResult<PostAgentsAddAgentCallbackResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostAgentsAddAgentCallbackResponses, unknown, ThrowOnError>({
            url: '/agentapp/agents/{id}/callbacks',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class IdentityApi {
    public static getIdentityGetIdentity<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetIdentityData, ThrowOnError>): RequestResult<GetIdentityGetIdentityResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityGetIdentityResponses, unknown, ThrowOnError>({ url: '/agentapp/identity', ...options });
    }
    
    public static getIdentityGetSrpcToken<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetSrpcTokenData, ThrowOnError>): RequestResult<GetIdentityGetSrpcTokenResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityGetSrpcTokenResponses, unknown, ThrowOnError>({ url: '/agentapp/identity/srpc-token', ...options });
    }
    
    public static getIdentityGetStats<ThrowOnError extends boolean = false>(options?: Options<GetIdentityGetStatsData, ThrowOnError>): RequestResult<GetIdentityGetStatsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetIdentityGetStatsResponses, unknown, ThrowOnError>({ url: '/agentapp/identity/stats', ...options });
    }
}

export class CardTokenApi {
    public static postCardTokenCreateToken<ThrowOnError extends boolean = false>(options: Options<PostCardTokenCreateTokenData, ThrowOnError>): RequestResult<PostCardTokenCreateTokenResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCardTokenCreateTokenResponses, unknown, ThrowOnError>({
            url: '/agentapp/card-token',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class DebtorsApi {
    public static getDebtorsListDebtors<ThrowOnError extends boolean = false>(options?: Options<GetDebtorsListDebtorsData, ThrowOnError>): RequestResult<GetDebtorsListDebtorsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetDebtorsListDebtorsResponses, unknown, ThrowOnError>({ url: '/agentapp/debtors', ...options });
    }
    
    public static getDebtorsListRescheduledDebtors<ThrowOnError extends boolean = false>(options?: Options<GetDebtorsListRescheduledDebtorsData, ThrowOnError>): RequestResult<GetDebtorsListRescheduledDebtorsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetDebtorsListRescheduledDebtorsResponses, unknown, ThrowOnError>({ url: '/agentapp/debtors/rescheduled', ...options });
    }
    
    public static deleteDebtorsDeleteRescheduledEvent<ThrowOnError extends boolean = false>(options: Options<DeleteDebtorsDeleteRescheduledEventData, ThrowOnError>): RequestResult<DeleteDebtorsDeleteRescheduledEventResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteDebtorsDeleteRescheduledEventResponses, unknown, ThrowOnError>({ url: '/agentapp/debtors/{fileNumber}/rescheduled/{agentCode}/{isoTime}', ...options });
    }
    
    public static getDebtorsGetDebtor<ThrowOnError extends boolean = false>(options: Options<GetDebtorsGetDebtorData, ThrowOnError>): RequestResult<GetDebtorsGetDebtorResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetDebtorsGetDebtorResponses, unknown, ThrowOnError>({ url: '/agentapp/debtors/{fileNumber}', ...options });
    }
    
    public static putDebtorsUpdateAddress<ThrowOnError extends boolean = false>(options: Options<PutDebtorsUpdateAddressData, ThrowOnError>): RequestResult<PutDebtorsUpdateAddressResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsUpdateAddressResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/address',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDebtorsPostAction<ThrowOnError extends boolean = false>(options: Options<PostDebtorsPostActionData, ThrowOnError>): RequestResult<PostDebtorsPostActionResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebtorsPostActionResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/action',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDebtorsMarkFileClosed<ThrowOnError extends boolean = false>(options: Options<PostDebtorsMarkFileClosedData, ThrowOnError>): RequestResult<PostDebtorsMarkFileClosedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebtorsMarkFileClosedResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/close',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDebtorsSendReceipt<ThrowOnError extends boolean = false>(options: Options<PostDebtorsSendReceiptData, ThrowOnError>): RequestResult<PostDebtorsSendReceiptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebtorsSendReceiptResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/receipt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDebtorsSendPaymentLink<ThrowOnError extends boolean = false>(options: Options<PostDebtorsSendPaymentLinkData, ThrowOnError>): RequestResult<PostDebtorsSendPaymentLinkResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebtorsSendPaymentLinkResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/send-payment-link',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getDebtorsGetPaymentPlans<ThrowOnError extends boolean = false>(options: Options<GetDebtorsGetPaymentPlansData, ThrowOnError>): RequestResult<GetDebtorsGetPaymentPlansResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetDebtorsGetPaymentPlansResponses, unknown, ThrowOnError>({ url: '/agentapp/debtors/{fileNumber}/payment-plans', ...options });
    }
    
    public static postDebtorsCreatePaymentPlan<ThrowOnError extends boolean = false>(options: Options<PostDebtorsCreatePaymentPlanData, ThrowOnError>): RequestResult<PostDebtorsCreatePaymentPlanResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebtorsCreatePaymentPlanResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/payment-plans',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDebtorsCancelPaymentPlan<ThrowOnError extends boolean = false>(options: Options<PutDebtorsCancelPaymentPlanData, ThrowOnError>): RequestResult<PutDebtorsCancelPaymentPlanResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsCancelPaymentPlanResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/payment-plans/{planId}/cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDebtorsUpdatePaymentPlanMethod<ThrowOnError extends boolean = false>(options: Options<PutDebtorsUpdatePaymentPlanMethodData, ThrowOnError>): RequestResult<PutDebtorsUpdatePaymentPlanMethodResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsUpdatePaymentPlanMethodResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/payment-plans/{planId}/update-method',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDebtorsUpdatePaymentPlanNotifications<ThrowOnError extends boolean = false>(options: Options<PutDebtorsUpdatePaymentPlanNotificationsData, ThrowOnError>): RequestResult<PutDebtorsUpdatePaymentPlanNotificationsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsUpdatePaymentPlanNotificationsResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/payment-plans/{planId}/notifications',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postDebtorsCreateScheduledPayment<ThrowOnError extends boolean = false>(options: Options<PostDebtorsCreateScheduledPaymentData, ThrowOnError>): RequestResult<PostDebtorsCreateScheduledPaymentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostDebtorsCreateScheduledPaymentResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/scheduled-payments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDebtorsUpdateScheduledPaymentReceipt<ThrowOnError extends boolean = false>(options: Options<PutDebtorsUpdateScheduledPaymentReceiptData, ThrowOnError>): RequestResult<PutDebtorsUpdateScheduledPaymentReceiptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsUpdateScheduledPaymentReceiptResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/scheduled-payments/{paymentId}/receipt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDebtorsCancelScheduledPayment<ThrowOnError extends boolean = false>(options: Options<PutDebtorsCancelScheduledPaymentData, ThrowOnError>): RequestResult<PutDebtorsCancelScheduledPaymentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsCancelScheduledPaymentResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/scheduled-payments/{paymentId}/cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static putDebtorsReschedulePayment<ThrowOnError extends boolean = false>(options: Options<PutDebtorsReschedulePaymentData, ThrowOnError>): RequestResult<PutDebtorsReschedulePaymentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutDebtorsReschedulePaymentResponses, unknown, ThrowOnError>({
            url: '/agentapp/debtors/{fileNumber}/scheduled-payments/{paymentId}/reschedule',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class CallsApi {
    public static getCallsGetCalls<ThrowOnError extends boolean = false>(options?: Options<GetCallsGetCallsData, ThrowOnError>): RequestResult<GetCallsGetCallsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCallsGetCallsResponses, unknown, ThrowOnError>({ url: '/agentapp/calls', ...options });
    }
    
    public static getCallsGetCallRecording<ThrowOnError extends boolean = false>(options: Options<GetCallsGetCallRecordingData, ThrowOnError>): RequestResult<GetCallsGetCallRecordingResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetCallsGetCallRecordingResponses, unknown, ThrowOnError>({ url: '/agentapp/calls/{id}/recording', ...options });
    }
    
    public static getCallsGetRecentCalls<ThrowOnError extends boolean = false>(options?: Options<GetCallsGetRecentCallsData, ThrowOnError>): RequestResult<GetCallsGetRecentCallsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCallsGetRecentCallsResponses, unknown, ThrowOnError>({ url: '/agentapp/calls/recent', ...options });
    }
}

export class CampaignsApi {
    public static getCampaignsListCampaigns<ThrowOnError extends boolean = false>(options?: Options<GetCampaignsListCampaignsData, ThrowOnError>): RequestResult<GetCampaignsListCampaignsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetCampaignsListCampaignsResponses, unknown, ThrowOnError>({ url: '/agentapp/campaigns', ...options });
    }
}

export class CampaignLoaderApi {
    public static postCampaignLoaderLoadCampaign<ThrowOnError extends boolean = false>(options: Options<PostCampaignLoaderLoadCampaignData, ThrowOnError>): RequestResult<PostCampaignLoaderLoadCampaignResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostCampaignLoaderLoadCampaignResponses, unknown, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/agentapp/campaigns/load',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
}

export class MetaApi {
    public static getMetaGetConfig<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetConfigData, ThrowOnError>): RequestResult<GetMetaGetConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetConfigResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/config', ...options });
    }
    
    public static putMetaSetConfig<ThrowOnError extends boolean = false>(options: Options<PutMetaSetConfigData, ThrowOnError>): RequestResult<PutMetaSetConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutMetaSetConfigResponses, unknown, ThrowOnError>({
            url: '/agentapp/meta/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getMetaGetActionCodes<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetActionCodesData, ThrowOnError>): RequestResult<GetMetaGetActionCodesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetActionCodesResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/action-codes', ...options });
    }
    
    public static getMetaGetStatuses<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetStatusesData, ThrowOnError>): RequestResult<GetMetaGetStatusesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetStatusesResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/statuses', ...options });
    }
    
    public static getMetaGetTrustCodes<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetTrustCodesData, ThrowOnError>): RequestResult<GetMetaGetTrustCodesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetTrustCodesResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/trust-codes', ...options });
    }
    
    public static getMetaGetCryptoKey<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetCryptoKeyData, ThrowOnError>): RequestResult<GetMetaGetCryptoKeyResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetCryptoKeyResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/crypto-key', ...options });
    }
    
    public static getMetaGetAgents<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetAgentsData, ThrowOnError>): RequestResult<GetMetaGetAgentsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetAgentsResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/agents', ...options });
    }
    
    public static getMetaValidateRoutingNumber<ThrowOnError extends boolean = false>(options: Options<GetMetaValidateRoutingNumberData, ThrowOnError>): RequestResult<GetMetaValidateRoutingNumberResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetMetaValidateRoutingNumberResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/routing-numbers/validate', ...options });
    }
    
    public static getMetaGetClientInfo<ThrowOnError extends boolean = false>(options: Options<GetMetaGetClientInfoData, ThrowOnError>): RequestResult<GetMetaGetClientInfoResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetMetaGetClientInfoResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/client-info/{clientNumber}', ...options });
    }
    
    public static getMetaGetDids<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetDidsData, ThrowOnError>): RequestResult<GetMetaGetDidsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetDidsResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/dids', ...options });
    }
    
    public static getMetaGetQueues<ThrowOnError extends boolean = false>(options?: Options<GetMetaGetQueuesData, ThrowOnError>): RequestResult<GetMetaGetQueuesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMetaGetQueuesResponses, unknown, ThrowOnError>({ url: '/agentapp/meta/queues', ...options });
    }
}

export class MlCohortApi {
    public static getMlCohortGetConfig<ThrowOnError extends boolean = false>(options?: Options<GetMlCohortGetConfigData, ThrowOnError>): RequestResult<GetMlCohortGetConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMlCohortGetConfigResponses, unknown, ThrowOnError>({ url: '/agentapp/ml-cohort/config', ...options });
    }
    
    public static putMlCohortSetConfig<ThrowOnError extends boolean = false>(options: Options<PutMlCohortSetConfigData, ThrowOnError>): RequestResult<PutMlCohortSetConfigResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutMlCohortSetConfigResponses, unknown, ThrowOnError>({
            url: '/agentapp/ml-cohort/config',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * How much of the live queue the current rules would turn away. Read-only — it reports the blast radius of an edit without applying it, so an operator can adjust or revert before the accounts are actually worked.
     */
    public static getMlCohortGetQueueImpact<ThrowOnError extends boolean = false>(options?: Options<GetMlCohortGetQueueImpactData, ThrowOnError>): RequestResult<GetMlCohortGetQueueImpactResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetMlCohortGetQueueImpactResponses, unknown, ThrowOnError>({ url: '/agentapp/ml-cohort/queue-impact', ...options });
    }
}

export class Ph1CcApi {
    public static getPh1CcGetClients<ThrowOnError extends boolean = false>(options?: Options<GetPh1CcGetClientsData, ThrowOnError>): RequestResult<GetPh1CcGetClientsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPh1CcGetClientsResponses, unknown, ThrowOnError>({ url: '/agentapp/ph1cc/clients', ...options });
    }
    
    public static getPh1CcGetClientRecords<ThrowOnError extends boolean = false>(options: Options<GetPh1CcGetClientRecordsData, ThrowOnError>): RequestResult<GetPh1CcGetClientRecordsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPh1CcGetClientRecordsResponses, unknown, ThrowOnError>({ url: '/agentapp/ph1cc/clients/{clientId}', ...options });
    }
    
    public static postPh1CcPurge<ThrowOnError extends boolean = false>(options?: Options<PostPh1CcPurgeData, ThrowOnError>): RequestResult<PostPh1CcPurgeResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostPh1CcPurgeResponses, unknown, ThrowOnError>({ url: '/agentapp/ph1cc/purge', ...options });
    }
}

export class PifCreditRemovalsApi {
    public static getPifCreditRemovalsGetPifCreditRemovals<ThrowOnError extends boolean = false>(options?: Options<GetPifCreditRemovalsGetPifCreditRemovalsData, ThrowOnError>): RequestResult<GetPifCreditRemovalsGetPifCreditRemovalsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPifCreditRemovalsGetPifCreditRemovalsResponses, unknown, ThrowOnError>({ url: '/agentapp/pif-credit-removals', ...options });
    }
    
    public static getPifCreditRemovalsGetPifCreditRemoval<ThrowOnError extends boolean = false>(options: Options<GetPifCreditRemovalsGetPifCreditRemovalData, ThrowOnError>): RequestResult<GetPifCreditRemovalsGetPifCreditRemovalResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPifCreditRemovalsGetPifCreditRemovalResponses, unknown, ThrowOnError>({ url: '/agentapp/pif-credit-removals/{id}', ...options });
    }
}

export class ReceiptsApi {
    public static getReceiptsGetReceipts<ThrowOnError extends boolean = false>(options?: Options<GetReceiptsGetReceiptsData, ThrowOnError>): RequestResult<GetReceiptsGetReceiptsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetReceiptsGetReceiptsResponses, unknown, ThrowOnError>({ url: '/agentapp/receipts', ...options });
    }
    
    public static postReceiptsPrintReceipts<ThrowOnError extends boolean = false>(options: Options<PostReceiptsPrintReceiptsData, ThrowOnError>): RequestResult<PostReceiptsPrintReceiptsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostReceiptsPrintReceiptsResponses, unknown, ThrowOnError>({
            url: '/agentapp/receipts/print',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postReceiptsPrintReceiptEnvelopes<ThrowOnError extends boolean = false>(options: Options<PostReceiptsPrintReceiptEnvelopesData, ThrowOnError>): RequestResult<PostReceiptsPrintReceiptEnvelopesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostReceiptsPrintReceiptEnvelopesResponses, unknown, ThrowOnError>({
            url: '/agentapp/receipts/print-envelopes',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postReceiptsMarkMailed<ThrowOnError extends boolean = false>(options: Options<PostReceiptsMarkMailedData, ThrowOnError>): RequestResult<PostReceiptsMarkMailedResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostReceiptsMarkMailedResponses, unknown, ThrowOnError>({
            url: '/agentapp/receipts/mark-mailed',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getReceiptsGetReceipt<ThrowOnError extends boolean = false>(options: Options<GetReceiptsGetReceiptData, ThrowOnError>): RequestResult<GetReceiptsGetReceiptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetReceiptsGetReceiptResponses, unknown, ThrowOnError>({ url: '/agentapp/receipts/{id}/{format}', ...options });
    }
}

export class SecureFilesApi {
    public static getSecureFilesGetQueued<ThrowOnError extends boolean = false>(options?: Options<GetSecureFilesGetQueuedData, ThrowOnError>): RequestResult<GetSecureFilesGetQueuedResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSecureFilesGetQueuedResponses, unknown, ThrowOnError>({ url: '/agentapp/files/queued', ...options });
    }
    
    public static getSecureFilesGetSent<ThrowOnError extends boolean = false>(options?: Options<GetSecureFilesGetSentData, ThrowOnError>): RequestResult<GetSecureFilesGetSentResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSecureFilesGetSentResponses, unknown, ThrowOnError>({ url: '/agentapp/files/sent', ...options });
    }
    
    public static getSecureFilesGetSentDetails<ThrowOnError extends boolean = false>(options: Options<GetSecureFilesGetSentDetailsData, ThrowOnError>): RequestResult<GetSecureFilesGetSentDetailsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSecureFilesGetSentDetailsResponses, unknown, ThrowOnError>({ url: '/agentapp/files/sent/{id}/details', ...options });
    }
    
    public static getSecureFilesGetPreviewUrl<ThrowOnError extends boolean = false>(options: Options<GetSecureFilesGetPreviewUrlData, ThrowOnError>): RequestResult<GetSecureFilesGetPreviewUrlResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetSecureFilesGetPreviewUrlResponses, unknown, ThrowOnError>({ url: '/agentapp/files/{id}/preview-url', ...options });
    }
    
    public static postSecureFilesSendFiles<ThrowOnError extends boolean = false>(options: Options<PostSecureFilesSendFilesData, ThrowOnError>): RequestResult<PostSecureFilesSendFilesResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSecureFilesSendFilesResponses, unknown, ThrowOnError>({
            url: '/agentapp/files/send',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSecureFilesGetClients<ThrowOnError extends boolean = false>(options?: Options<GetSecureFilesGetClientsData, ThrowOnError>): RequestResult<GetSecureFilesGetClientsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSecureFilesGetClientsResponses, unknown, ThrowOnError>({ url: '/agentapp/files/clients', ...options });
    }
    
    public static postSecureFilesCreateClient<ThrowOnError extends boolean = false>(options: Options<PostSecureFilesCreateClientData, ThrowOnError>): RequestResult<PostSecureFilesCreateClientResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostSecureFilesCreateClientResponses, unknown, ThrowOnError>({
            url: '/agentapp/files/clients',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static deleteSecureFilesDeleteClient<ThrowOnError extends boolean = false>(options: Options<DeleteSecureFilesDeleteClientData, ThrowOnError>): RequestResult<DeleteSecureFilesDeleteClientResponses, unknown, ThrowOnError> {
        return (options.client ?? client).delete<DeleteSecureFilesDeleteClientResponses, unknown, ThrowOnError>({ url: '/agentapp/files/clients/{clientId}', ...options });
    }
    
    public static putSecureFilesUpdateClientEmails<ThrowOnError extends boolean = false>(options: Options<PutSecureFilesUpdateClientEmailsData, ThrowOnError>): RequestResult<PutSecureFilesUpdateClientEmailsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSecureFilesUpdateClientEmailsResponses, unknown, ThrowOnError>({
            url: '/agentapp/files/clients/{clientId}/emails',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getSecureFilesGetTemplates<ThrowOnError extends boolean = false>(options?: Options<GetSecureFilesGetTemplatesData, ThrowOnError>): RequestResult<GetSecureFilesGetTemplatesResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetSecureFilesGetTemplatesResponses, unknown, ThrowOnError>({ url: '/agentapp/files/templates', ...options });
    }
    
    public static putSecureFilesUpdateTemplate<ThrowOnError extends boolean = false>(options: Options<PutSecureFilesUpdateTemplateData, ThrowOnError>): RequestResult<PutSecureFilesUpdateTemplateResponses, unknown, ThrowOnError> {
        return (options.client ?? client).put<PutSecureFilesUpdateTemplateResponses, unknown, ThrowOnError>({
            url: '/agentapp/files/templates/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PublicFreeSwitchEventApi {
    public static postPublicFreeSwitchEventHandleEvent<ThrowOnError extends boolean = false>(options: Options<PostPublicFreeSwitchEventHandleEventData, ThrowOnError>): RequestResult<PostPublicFreeSwitchEventHandleEventResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicFreeSwitchEventHandleEventResponses, unknown, ThrowOnError>({
            url: '/public/freeswitch-event',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PublicIvrApi {
    public static postPublicIvrHandleTwiml<ThrowOnError extends boolean = false>(options?: Options<PostPublicIvrHandleTwimlData, ThrowOnError>): RequestResult<PostPublicIvrHandleTwimlResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).post<PostPublicIvrHandleTwimlResponses, unknown, ThrowOnError>({ url: '/public/ivr/twiml', ...options });
    }
    
    public static getPublicIvrHandleTts<ThrowOnError extends boolean = false>(options?: Options<GetPublicIvrHandleTtsData, ThrowOnError>): RequestResult<GetPublicIvrHandleTtsResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPublicIvrHandleTtsResponses, unknown, ThrowOnError>({ url: '/public/ivr/tts', ...options });
    }
}

export class PublicFilesApi {
    public static postPublicFilesUpload<ThrowOnError extends boolean = false>(options: Options<PostPublicFilesUploadData, ThrowOnError>): RequestResult<PostPublicFilesUploadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicFilesUploadResponses, unknown, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/public/files',
            ...options,
            headers: {
                'Content-Type': null,
                ...options.headers
            }
        });
    }
    
    public static getPublicFilesGetFileInfo<ThrowOnError extends boolean = false>(options: Options<GetPublicFilesGetFileInfoData, ThrowOnError>): RequestResult<GetPublicFilesGetFileInfoResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicFilesGetFileInfoResponses, unknown, ThrowOnError>({ url: '/public/files/{token}', ...options });
    }
    
    public static getPublicFilesDownload<ThrowOnError extends boolean = false>(options: Options<GetPublicFilesDownloadData, ThrowOnError>): RequestResult<GetPublicFilesDownloadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicFilesDownloadResponses, unknown, ThrowOnError>({ url: '/public/files/{token}/download', ...options });
    }
    
    public static getPublicFilesGetRecipientFileInfo<ThrowOnError extends boolean = false>(options: Options<GetPublicFilesGetRecipientFileInfoData, ThrowOnError>): RequestResult<GetPublicFilesGetRecipientFileInfoResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicFilesGetRecipientFileInfoResponses, unknown, ThrowOnError>({ url: '/public/files/r/{recipientToken}', ...options });
    }
    
    public static getPublicFilesRecipientDownload<ThrowOnError extends boolean = false>(options: Options<GetPublicFilesRecipientDownloadData, ThrowOnError>): RequestResult<GetPublicFilesRecipientDownloadResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicFilesRecipientDownloadResponses, unknown, ThrowOnError>({ url: '/public/files/r/{recipientToken}/download', ...options });
    }
}

export class PublicPayApi {
    public static getPublicPayGetConfig<ThrowOnError extends boolean = false>(options?: Options<GetPublicPayGetConfigData, ThrowOnError>): RequestResult<GetPublicPayGetConfigResponses, unknown, ThrowOnError> {
        return (options?.client ?? client).get<GetPublicPayGetConfigResponses, unknown, ThrowOnError>({ url: '/public/pay/config', ...options });
    }
    
    public static postPublicPayScheduledPayments<ThrowOnError extends boolean = false>(options: Options<PostPublicPayScheduledPaymentsData, ThrowOnError>): RequestResult<PostPublicPayScheduledPaymentsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayScheduledPaymentsResponses, unknown, ThrowOnError>({
            url: '/public/pay/scheduled-payments',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayAuth<ThrowOnError extends boolean = false>(options: Options<PostPublicPayAuthData, ThrowOnError>): RequestResult<PostPublicPayAuthResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayAuthResponses, unknown, ThrowOnError>({
            url: '/public/pay/auth',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayAccounts<ThrowOnError extends boolean = false>(options: Options<PostPublicPayAccountsData, ThrowOnError>): RequestResult<PostPublicPayAccountsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayAccountsResponses, unknown, ThrowOnError>({
            url: '/public/pay/accounts',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayPayment<ThrowOnError extends boolean = false>(options: Options<PostPublicPayPaymentData, ThrowOnError>): RequestResult<PostPublicPayPaymentResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayPaymentResponses, unknown, ThrowOnError>({
            url: '/public/pay/payment',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayReceipt<ThrowOnError extends boolean = false>(options: Options<PostPublicPayReceiptData, ThrowOnError>): RequestResult<PostPublicPayReceiptResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayReceiptResponses, unknown, ThrowOnError>({
            url: '/public/pay/receipt',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayPlanOptions<ThrowOnError extends boolean = false>(options: Options<PostPublicPayPlanOptionsData, ThrowOnError>): RequestResult<PostPublicPayPlanOptionsResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayPlanOptionsResponses, unknown, ThrowOnError>({
            url: '/public/pay/plan-options',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayPlanEnroll<ThrowOnError extends boolean = false>(options: Options<PostPublicPayPlanEnrollData, ThrowOnError>): RequestResult<PostPublicPayPlanEnrollResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayPlanEnrollResponses, unknown, ThrowOnError>({
            url: '/public/pay/plan-enroll',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayPlanStatus<ThrowOnError extends boolean = false>(options: Options<PostPublicPayPlanStatusData, ThrowOnError>): RequestResult<PostPublicPayPlanStatusResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayPlanStatusResponses, unknown, ThrowOnError>({
            url: '/public/pay/plan-status',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postPublicPayPlanUpdateMethod<ThrowOnError extends boolean = false>(options: Options<PostPublicPayPlanUpdateMethodData, ThrowOnError>): RequestResult<PostPublicPayPlanUpdateMethodResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPublicPayPlanUpdateMethodResponses, unknown, ThrowOnError>({
            url: '/public/pay/plan-update-method',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class PublicReceiptsApi {
    public static getPublicReceiptsGetReceiptPublic<ThrowOnError extends boolean = false>(options: Options<GetPublicReceiptsGetReceiptPublicData, ThrowOnError>): RequestResult<GetPublicReceiptsGetReceiptPublicResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicReceiptsGetReceiptPublicResponses, unknown, ThrowOnError>({ url: '/public/receipts/{idStr}', ...options });
    }
    
    public static getPublicReceiptsGetReceiptPublicSimple<ThrowOnError extends boolean = false>(options: Options<GetPublicReceiptsGetReceiptPublicSimpleData, ThrowOnError>): RequestResult<GetPublicReceiptsGetReceiptPublicSimpleResponses, unknown, ThrowOnError> {
        return (options.client ?? client).get<GetPublicReceiptsGetReceiptPublicSimpleResponses, unknown, ThrowOnError>({ url: '/public/receipt/{fileNumber}/{paymentDate}/{receiptId}', ...options });
    }
}

export class PostmarkWebhookApi {
    public static postPostmarkWebhookHandleWebhook<ThrowOnError extends boolean = false>(options: Options<PostPostmarkWebhookHandleWebhookData, ThrowOnError>): RequestResult<PostPostmarkWebhookHandleWebhookResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostPostmarkWebhookHandleWebhookResponses, unknown, ThrowOnError>({
            url: '/public/webhooks/postmark',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class TelnyxWebhookApi {
    public static postTelnyxWebhookHandleWebhook<ThrowOnError extends boolean = false>(options: Options<PostTelnyxWebhookHandleWebhookData, ThrowOnError>): RequestResult<PostTelnyxWebhookHandleWebhookResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostTelnyxWebhookHandleWebhookResponses, unknown, ThrowOnError>({
            url: '/public/webhooks/telnyx',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}

export class UsaepayGatewayApi {
    public static postUsaepayGatewayHandleGatewayRequest<ThrowOnError extends boolean = false>(options: Options<PostUsaepayGatewayHandleGatewayRequestData, ThrowOnError>): RequestResult<PostUsaepayGatewayHandleGatewayRequestResponses, unknown, ThrowOnError> {
        return (options.client ?? client).post<PostUsaepayGatewayHandleGatewayRequestResponses, unknown, ThrowOnError>({
            url: '/secure/gate.php',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
